var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.$modal.fullWidth },
    [
      _c("v-flex", [
        _c("p", { class: _vm.$modal.modalDangerText }, [
          _vm._v("\n      " + _vm._s(_vm.message) + "\n    ")
        ])
      ]),
      _vm._v(" "),
      _vm._t("default"),
      _vm._v(" "),
      _c(
        "v-flex",
        { class: _vm.$modal.modalDangerButtons },
        [
          _c(
            "BaseButton",
            {
              class: [_vm.$modal.noBtn, _vm.$modal.descktopBtn],
              attrs: { "button-style": "Cancel" },
              on: { click: _vm.cancel }
            },
            [_vm._v("\n      " + _vm._s(_vm.cancelText) + "\n    ")]
          ),
          _vm._v(" "),
          _c(
            "BaseButton",
            {
              class: [_vm.$modal.dangerBtn, _vm.$modal.descktopBtn],
              attrs: { "button-style": "Danger" },
              on: { click: _vm.confirm }
            },
            [_vm._v("\n      " + _vm._s(_vm.confirmText) + "\n    ")]
          )
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/ConfirmModalContent.vue?vue&type=template&id=1f5d0028&
// module id = null
// module chunks = 